import _ from '@/utils/lodash-optimized'

import { NEW_TOASTS, NEW_TOAST, CLOSE_TOAST, RESET } from './actions.js'

const initialState = {
  toastStack: [],
  error: false
}

export default function reducer (state = initialState, action) {
  switch (action.type) {
    case NEW_TOASTS: {
      let toasts = [ ...action.toasts, ...state.toastStack ]
      let toastStack = _.uniqWith(toasts, _.isEqual)

      return {
        toastStack
      }
    }

    case NEW_TOAST: {
      let toasts = [ action.toast, ...state.toastStack ]
      let toastStack = _.uniqWith(toasts, _.isEqual)

      return {
        toastStack
      }
    }

    case CLOSE_TOAST:
      return {
        toastStack: state.toastStack.filter(t => t.id !== action.id)
      }

    case RESET:
      return initialState

    default:
      return state
  }
}
